export default __webpack_public_path__ + "static/commmune-circle-f12b5930ba202964bfacd3170fb6493c.svg";